import * as React from "react";
import PropTypes from 'prop-types';

const SvgMailFill = props => {
  if (props.id !== "_svgmailfill") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 -6 30 30" {...props}><path d="M12.487 8.985L2.406 1.315.905.153C1.073.07 1.277 0 1.42 0h23.449c.134 0 .44 0 .709.115l-1.586 1.2-9.971 7.67c-.136.1-.53.22-.767.22-.238 0-.588-.092-.767-.22zM26.39 1.15l.006.024c.02.033.03.07.03.11v.195l-.023 15.615c0 1.315-.877 2.191-2.192 2.191H2.296c-1.315 0-2.191-.876-2.191-2.191L.08 1.414V1.22c0-.013.003-.025.005-.038L1.6 2.355l.004.003.004.003 10.081 7.67.016.013.017.011c.48.343 1.124.464 1.53.464.439 0 1.13-.167 1.549-.476l.01-.008.01-.008L24.79 2.36l1.6-1.21z" /></svg>;
};

SvgMailFill.displayName = "_svgmailfill";
SvgMailFill.propTypes = {
  id: PropTypes.string
};
SvgMailFill.defaultProps = {
  id: ''
};
export default SvgMailFill;